.wrap {
  display: flex;
  flex-direction: column;
  gap: var(--s-3);
  font-family: var(--font-body);
}
.texto {
  display: flex;
  justify-content: space-between;
  gap: var(--s-5);
  font-size: var(--fs-2xs);
  color: var(--text-muted);
}
.pct {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  color: var(--text-strong);
}
.barra {
  position: relative;
  height: var(--s-2);
  border-radius: var(--r-full);
  background: var(--surface-muted);
  overflow: hidden;
}
.relleno {
  position: absolute;
  inset: 0 auto 0 0;
  width: var(--_p, 0%);
  border-radius: inherit;
  background: var(--action-primary);
  transition: width var(--dur-base) var(--ease-standard);
}
.barra[data-indeterminate] .relleno {
  width: 40%;
  animation: vaiven 1.2s var(--ease-standard) infinite;
}
@keyframes vaiven {
  from {
    left: -40%;
  }
  to {
    left: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .relleno {
    transition: none;
  }
  .barra[data-indeterminate] .relleno {
    animation-duration: 2.4s;
  }
}
